import { Box, Button } from '@mui/material';
import { ReactNode, useEffect } from 'react';

import { Loader } from 'shared/ui/Loader/Loader';

interface FixedSaveBarProps {
    saveText?: string;
    cancelText?: string;
    saveColor?:
        | 'primary'
        | 'secondary'
        | 'error'
        | 'info'
        | 'success'
        | 'warning';
    saveDisabled?: boolean;
    saveLoading?: boolean;
    onSave?: () => void;
    onCancel?: () => void;
    show?: boolean;
    children?: ReactNode;
    sx?: any;
}

const FixedSaveBar = ({
    saveText = 'Save',
    cancelText = 'Cancel',
    saveColor = 'primary',
    saveDisabled = false,
    saveLoading = false,
    onSave,
    onCancel,
    show = true,
    children,
    sx,
}: FixedSaveBarProps) => {
    // Add sticky-visible class to page-content when show is true
    // This kills the bottom padding because... things were getting weird when you scrolled down
    // I don't have time to debug it... so this is a hack.
    // I'm sorry...
    useEffect(() => {
        const pageContent = document.querySelector('.page-content');
        if (show) {
            pageContent?.classList.add('sticky-visible');
        }

        return () => {
            pageContent?.classList.remove('sticky-visible');
        };
    }, [show]);

    if (!show) {
        return null;
    }

    return (
        <Box
            sx={{
                position: 'sticky',
                bottom: '0',
                left: '0',
                right: '0',
                backgroundColor: 'background.paper',
                padding: '16px 24px',
                zIndex: 1000,
                display: 'flex',
                gap: '20px',
                justifyContent: 'right',
                alignItems: 'center',
                ...sx,
            }}
        >
            {children}
            <Button color="primary" onClick={onCancel} disabled={saveLoading}>
                {cancelText}
            </Button>
            <Button
                startIcon={saveLoading && <Loader color="inherit" />}
                className={saveDisabled || saveLoading ? 'Mui-disabled' : ''}
                style={{
                    pointerEvents: 'auto',
                }}
                variant="contained"
                color={saveColor}
                onClick={saveDisabled || saveLoading ? undefined : onSave}
                disabled={saveDisabled || saveLoading}
            >
                {saveText}
            </Button>
        </Box>
    );
};

export { FixedSaveBar };
